// extracted by mini-css-extract-plugin
export var optionGrid = "_90-7";
export var optionList = "_90-6";
export var questionsBlock = "_90-9";
export var spacer = "_90-5";
export var stepCenteredContent = "_90-3";
export var stepInner = "_90-0";
export var stepInnerFullWidth = "_90-1";
export var stepInnerLockScroll = "_90-2";
export var stepTransitionFrame = "_90-4";
export var welcomeBlock = "_90-8";